import { GuestDetails } from '../../../guestDetails';
import { Entitlement, EntitlementHotlist } from '../../models';
import { getActiveHotlistsForGuest } from '../../../hotlist/module';
import ImmutableMap from '../../../../language/ImmutableMap';


export const dtwIsHotlisted = (
  entitlement: Entitlement,
  guest: GuestDetails,
  hotlists: ImmutableMap<EntitlementHotlist[]>
) =>
  !!getActiveHotlistsForGuest(guest, hotlists)
    .find(list => list.entitlementId === entitlement.entitlementId);
